import { UFOExperience } from '@atlaskit/ufo/experience';
import { ExperiencePerformanceTypes, ExperienceTypes } from '@atlaskit/ufo/experience-types';

/** Creates a distinct UFO experience for one mounted Remix loading bar. */
export const createRemixLoadingBarExperience = (instanceId: string): UFOExperience =>
	new UFOExperience(
		'remix-loading-bar',
		{
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		},
		instanceId,
	);
